import { CognitoUserPool } from 'amazon-cognito-identity-js';
import Auth from '@aws-amplify/auth';
import jwtDecode from 'jwt-decode';
import { promisify } from 'es6-promisify';
import config from '$config';

const UserPoolId = config.cognito.userPoolId;
const ClientId = config.cognito.clientId;

// Legacy Pool - kept for backward compatibility but prefer using Amplify Auth
export const Pool = new CognitoUserPool({ UserPoolId, ClientId });

/**
 * Get current session using Amplify Auth
 * Amplify v5 manages auth session differently than raw amazon-cognito-identity-js
 */
export const getSession = async () => {
  const session = await Auth.currentSession();
  return session;
};

export const refreshSession = async () => {
  // Amplify handles token refresh automatically, but we can force it
  const session = await Auth.currentSession();
  return session;
};

export const getIdToken = async () => {
  const session = await getSession();
  return session.getIdToken().getJwtToken();
};

export const getTokenExpiresIn = (token) => {
  const decoded = jwtDecode(token);
  if (!decoded) throw new Error('Invalid JWT token');
  return decoded.exp * 1000 - Date.now();
};
